/**
 * Job-service price endpoints for odl_app.
 *
 * Per-customer pricing records for job service definitions. The list is served
 * via EntityGrid (dataSource/apiClient) scoped by filter[customer_id]; this
 * module injects the write mutations (create / patch / remove) only.
 *
 * Contains:
 * - jobServicePricesApi   — the injected endpoint slice
 * - hook re-exports       — useCreateJobServicePriceMutation,
 *                           usePatchJobServicePriceMutation,
 *                           useRemoveJobServicePriceMutation
 */

import { entitiesApi } from './entitiesApi';

const jobServicePricesApi = entitiesApi.injectEndpoints({
  endpoints: build => ({
    /**
     * Create a new job-service price record.
     *
     * @param {{ body: object }} arg  body includes { customer_id, service_id, installer_pay, … }
     */
    createJobServicePrice: build.mutation({
      query: ({ body }) => ({
        url: 'job-service-prices/',
        method: 'post',
        data: body,
      }),
      transformResponse: b => b.data,
      invalidatesTags: [{ type: 'JobServicePrice', id: 'LIST' }],
    }),

    /**
     * Partial update a job-service price record.
     *
     * @param {{ id: string|number, body: object }} arg
     */
    patchJobServicePrice: build.mutation({
      query: ({ id, body }) => ({
        url: `job-service-prices/${id}/`,
        method: 'patch',
        data: body,
      }),
      transformResponse: b => b.data,
      invalidatesTags: (result, error, { id }) => [
        { type: 'JobServicePrice', id: 'LIST' },
        { type: 'JobServicePrice', id },
      ],
    }),

    /**
     * Delete a job-service price record.
     *
     * @param {{ id: string|number }} arg
     */
    removeJobServicePrice: build.mutation({
      query: ({ id }) => ({
        url: `job-service-prices/${id}/`,
        method: 'delete',
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'JobServicePrice', id: 'LIST' },
        { type: 'JobServicePrice', id },
      ],
    }),
  }),
});

export { jobServicePricesApi };
export const { useCreateJobServicePriceMutation, usePatchJobServicePriceMutation, useRemoveJobServicePriceMutation } =
  jobServicePricesApi;
